"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateOrDelete = exports.createUpdateOrDelete = exports.findDelete = void 0;
function createOrUpdate(array = [], transform, pk = 'id') {
    return array.reduce((acc, i) => {
        const obj = transform ? transform(i) : i;
        if (!obj)
            return acc;
        const key = i[pk] ? 'update' : 'create';
        const value = acc;
        return Object.assign(Object.assign({}, acc), { [key]: [
                ...(value[key] || []),
                i[pk]
                    ? {
                        data: obj,
                        where: { [pk]: i[pk] },
                    }
                    : obj,
            ] });
    }, {});
}
function findDelete(current, initial, pk = 'id') {
    return initial
        .filter(i => i[pk] && !current.find(item => item[pk] === i[pk]))
        .map(i => ({ [pk]: i[pk] }));
}
exports.findDelete = findDelete;
function createUpdateOrDelete(current = [], initial = [], transform, pk = 'id') {
    const toDelete = findDelete(current, initial, pk);
    return Object.assign(Object.assign({}, createOrUpdate(current, transform, pk)), { delete: toDelete });
}
exports.createUpdateOrDelete = createUpdateOrDelete;
function updateOrDelete(current = [], initial = [], transform, pk = 'id') {
    const toDelete = findDelete(current, initial, pk);
    const toUpdate = current.map(i => {
        const obj = transform ? transform(i) : i;
        return {
            data: obj,
            where: { [pk]: i[pk] },
        };
    });
    return { delete: toDelete, update: toUpdate };
}
exports.updateOrDelete = updateOrDelete;
exports.default = createOrUpdate;
